import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { adminAPI } from '../../services/api';
import { FiFolder, FiCode, FiBookOpen, FiAward, FiMessageSquare, FiUsers } from 'react-icons/fi';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import './Dashboard.css';

const COLORS = ['#1a73e8', '#6c5ce7', '#00b894', '#fd79a8', '#fdcb6e', '#e17055'];

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getDashboard()
      .then(res => { if (res.success) setData(res.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;
  if (!data) return <div>Failed to load dashboard</div>;

  const widgets = [
    { label: 'Total Projects', value: data.totalProjects, icon: FiFolder, color: '#1a73e8' },
    { label: 'Total Skills', value: data.totalSkills, icon: FiCode, color: '#6c5ce7' },
    { label: 'Total Blogs', value: data.totalBlogs, icon: FiBookOpen, color: '#00b894' },
    { label: 'Certificates', value: data.totalCertificates, icon: FiAward, color: '#fd79a8' },
    { label: 'Contact Requests', value: data.totalContactRequests, icon: FiMessageSquare, color: '#fdcb6e' },
    { label: 'Total Visitors', value: data.totalVisitors, icon: FiUsers, color: '#e17055' },
  ];

  return (
    <div className="dashboard-page">
      <Helmet><title>Dashboard | Portfolio CMS</title></Helmet>

      <div className="dashboard-widgets">
        {widgets.map((w, i) => (
          <div key={i} className="dashboard-widget card">
            <div className="widget-icon" style={{ background: `${w.color}15`, color: w.color }}>
              <w.icon size={24} />
            </div>
            <div className="widget-info">
              <h3>{w.value}</h3>
              <p>{w.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-charts">
        <div className="chart-card card">
          <h3>Visitors Per Day (Last 7 Days)</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data.visitorsPerDay}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--border-color)" />
              <XAxis dataKey="label" stroke="var(--text-muted)" />
              <YAxis stroke="var(--text-muted)" />
              <Tooltip />
              <Bar dataKey="value" fill="#1a73e8" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card card">
          <h3>Blog Views</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie data={data.blogViews} dataKey="value" nameKey="label" cx="50%" cy="50%" outerRadius={100} label>
                {data.blogViews.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-card card">
          <h3>Project Views</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie data={data.projectViews} dataKey="value" nameKey="label" cx="50%" cy="50%" outerRadius={100} label>
                {data.projectViews.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
